module.exports = __webpack_public_path__ + "img/8.26c3d9b9.png";